// extracted by mini-css-extract-plugin
export default {"button-primary-action":"oYa8RsxUsYbroQrbaD8h","button-secondary-action":"WCrc3EcuADxDEZ1SicGu","button-tertiary-action":"uqctlLQPUvZm60MlqOLZ","login-footer":"offhDNf_DgcZqkAIdkIp"};